export const familyAntecedent = {
    restriction: "On ne peut pas modifier un antécédent d'un membre de la famille.",
    concerns: "Concerne"
}
